<script setup lang="ts">
import Capteur from "@icons/capteur.svg?url"
import CompteurElectrique from "@icons/compteur_electrique.svg?url"
import CompteurGaz from "@icons/compteur_gaz.svg?url"
import CompteurElectriqueSecondary from "@icons/compteur_electrique_secondary.svg?url"
import CompteurGazSecondary from "@icons/compteur_gaz_secondary.svg?url"
import CompteurCpcu from "@icons/compteur_cpcu.svg?url"
import StationMeteo from "@icons/station_meteo.svg?url"
import { computed } from "vue"
import { SOURCES_TYPES } from "@core/constants"
import { iconeUBordeaux } from "@core/components/source/meter/display/card/meter-ubordeaux.helper"
import type { FluideUBordeaux } from "@types"

type Props = {
    /**
     * Type de l'icône à afficher.
     */
    type: string
    /**
     * Taille de l'icône à afficher.
     */
    size?: number
    /**
     * Si l'icône est secondaire.
     */
    secondary?: boolean
    /**
     * Fluide d'un sous-compteur Université de Bordeaux (`ubordeaux`, DEV-2100),
     * lu dans `informations.ubordeaux.compteur.fluide`. Ignoré pour les autres
     * types. Absent ou null : icône neutre (compteur générique).
     */
    fluide?: FluideUBordeaux | null
}

const props = withDefaults(defineProps<Props>(), {
    type: "default",
    size: 24,
    secondary: false,
    fluide: null,
})

const getIconComposentByType = computed(() => {
    if (!props.type) return ""

    switch (props.type) {
        case SOURCES_TYPES.PCE:
            return props.secondary ? CompteurGazSecondary : CompteurGaz
        case SOURCES_TYPES.REGAZ:
            return CompteurGaz
        case SOURCES_TYPES.ELECSAVOIE:
        case SOURCES_TYPES.ELECSTRASBOURG:
            return CompteurElectriqueSecondary
        case SOURCES_TYPES.PDL:
            return props.secondary
                ? CompteurElectriqueSecondary
                : CompteurElectrique
        case SOURCES_TYPES.CPCU:
        case SOURCES_TYPES.DALKIA:
        case SOURCES_TYPES.SIGDU:
            return CompteurCpcu
        case SOURCES_TYPES.UBORDEAUX:
            return iconeUBordeaux(props.fluide) === "elec"
                ? CompteurElectriqueSecondary
                : CompteurCpcu
        case SOURCES_TYPES.METEOFRANCE:
        case SOURCES_TYPES.OPENMETEO:
        case SOURCES_TYPES.METEO:
            return StationMeteo
        default:
            return Capteur
    }
})
const getIconSize = computed(() => {
    return props.size
})
</script>

<template>
    <img
        class="base-source-icon"
        :style="{ width: `${getIconSize}px`, height: `${getIconSize}px` }"
        :src="getIconComposentByType"
        :width="getIconSize"
        :height="getIconSize"
    />
</template>
